import { Chip, ChipProps } from '@mui/material'

import { InspectionEntryStatusEntry } from '../../sdk'
import { determineTextColorByBgcolor } from '../../utils/determineTextColorByBgcolor'

export const InspectionEntryStatusChip = ({
  status,
  ...props
}: {
  status: InspectionEntryStatusEntry
} & ChipProps) => {
  const backgroundColor = '#' + status.info!.color!
  const textColor = determineTextColorByBgcolor(backgroundColor)
  return (
    <Chip
      sx={{
        bgcolor: backgroundColor,
        color: textColor
      }}
      label={status.info!.title}
      {...props}
    />
  )
}
